var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { utils as dataUtils } from '@easydata/core';
import { eqconsts, DataKind, ConditionPart, } from '@easyquery/core';
import { domel } from '@easydata/ui';
import { ExpressionRenderer } from './expression_renderer';
import { PopupMenu } from '../../../utils/popup_menu';
import { QPEditablePart } from '../../../types/qp_editable_part';
var ListExpressionRenderer = /** @class */ (function (_super) {
    __extends(ListExpressionRenderer, _super);
    function ListExpressionRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.menuItemsList = [];
        _this.showWhenReady = false;
        return _this;
    }
    ListExpressionRenderer.prototype.isEditable = function () {
        return !this.isReadOnly()
            && ((this.panel.options.editableParts & QPEditablePart.Value) === QPEditablePart.Value);
    };
    ListExpressionRenderer.prototype.setValue = function (value, silent) {
        if (silent === void 0) { silent = false; }
        var newValue = this.adjustNewValue(value);
        if (value !== this.expression.value) {
            var text = this.getValueText(value);
            this.expression.setContent(newValue, text);
            if (!silent) {
                this.expression.getParent().fireChangedEvent(ConditionPart.Value);
            }
        }
        return true;
    };
    ListExpressionRenderer.prototype.getValueText = function (value) {
        var result = "";
        if (Array.isArray(value)) {
            for (var _i = 0, _a = this.menuItemsList; _i < _a.length; _i++) {
                var item = _a[_i];
                if (value.indexOf(item.id) >= 0) {
                    result += item.text + ',';
                }
            }
        }
        else {
            for (var _b = 0, _c = this.menuItemsList; _b < _c.length; _b++) {
                var item = _c[_b];
                if (item.id === value) {
                    result += item.text + ',';
                }
            }
        }
        if (result) {
            result = result.substring(0, result.length - 1);
        }
        return result;
    };
    ListExpressionRenderer.prototype.getEmptyText = function () {
        return this.panel.options.emptyTextList || i18n.getText('MsgEmptyListValue');
    };
    ListExpressionRenderer.prototype.getListName = function () {
        return this.valueEditor.name;
    };
    ListExpressionRenderer.prototype.renderEditor = function () {
        var _this = this;
        this.fillMenuItemsList(function () {
            _this.renderMenuBlock();
        });
    };
    ListExpressionRenderer.prototype.getLabelText = function () {
        if (!this.expression.isEmpty()) {
            return this.expression.getText();
        }
        else {
            return this.getEmptyText();
        }
    };
    ListExpressionRenderer.prototype.showLoader = function () {
        //NOTHING TO DO
    };
    ListExpressionRenderer.prototype.hideLoader = function () {
        //NOTHING TO DO
    };
    ListExpressionRenderer.prototype.showEditor = function () {
        var _this = this;
        if (this.menu) {
            this.menu.showMenu({
                anchor: this.labelElement,
                selectedIds: this.getValuesAsArray(),
                itemSelectedCallback: function (item, selectedItems) {
                    if (!_this.menu.options.multiselect) {
                        _this.setValue(item.id);
                    }
                    else if (selectedItems) {
                        var selectedIds = [];
                        var selLength = selectedItems.length;
                        for (var i = 0; i < selLength; i++)
                            selectedIds.push(selectedItems[i].id);
                        _this.setValue(selectedIds);
                    }
                    return false;
                }
            });
        }
        else {
            this.showWhenReady = true;
            this.showLoader();
        }
    };
    ListExpressionRenderer.prototype.closeEditor = function () {
        this.menu.hideMenu();
    };
    ListExpressionRenderer.prototype.renderMenuBlock = function () {
        var multiSelect = false;
        if (this.expression) {
            multiSelect = this.expression.kind === DataKind.List;
        }
        var queryPanel = this.panel;
        var options = {
            items: this.menuItemsList,
            multiselect: multiSelect,
            container: queryPanel ? queryPanel.options.menuContainer : null,
            showSelected: true,
            showItemIds: queryPanel ? queryPanel.options.showIdsForListItems : false
        };
        if (queryPanel) {
            dataUtils.assignDeep(options, queryPanel.options.menuOptions);
        }
        ;
        var menuId = this.element.id;
        if (menuId) {
            options.id = menuId + '-EditorMenu';
        }
        if (queryPanel) {
            options.domWriteItemsId = queryPanel.options.domWriteItemsId;
        }
        ;
        options.buttons = {
            submit: i18n.getText('ButtonApply'),
            cancel: i18n.getText('ButtonCancel')
        };
        this.menu = new PopupMenu(options);
    };
    ListExpressionRenderer.prototype.getValuesAsArray = function () {
        if (this.expression.kind !== DataKind.List) {
            return [this.expression.value];
        }
        else {
            if (this.expression.value) {
                //splits value by ',' 
                var res = this.expression.value.match(/"[^"\\]*(?:\\.[^"\\]*)*"|[^,]+/g);
                return res
                    ? res.map(function (a) {
                        if (a.charAt(0) == '"' && a.charAt(a.length - 1) == '"') {
                            a = a.substring(1, a.length - 1);
                            return a.replace(/\"/g, '"');
                        }
                        else {
                            return a;
                        }
                    })
                    : [];
            }
            else
                return [];
        }
    };
    ListExpressionRenderer.prototype.adjustNewValue = function (newValue) {
        if (Array.isArray(newValue)) {
            return newValue.map(function (a) {
                if (a.indexOf(',') >= 0) {
                    a = a.replace(/"/g, '\"');
                    return '"' + a + '"';
                }
                else {
                    return a;
                }
            }).join(',');
        }
        else {
            return newValue;
        }
    };
    ListExpressionRenderer.prototype.fillMenuItemsList = function (onComplete) {
        this.menuItemsList = this.valueEditor.values;
        if (onComplete) {
            onComplete();
        }
    };
    ListExpressionRenderer.prototype.takeDefaultValue = function () {
        if (!this.menuItemsList)
            return;
        var itemLen = this.menuItemsList.length;
        var defValue = this.valueEditor.defValue;
        for (var i = 0; i < itemLen; i++) {
            var item = this.menuItemsList[i];
            if (item.isDefault || defValue == item.id) {
                this.setValue(item.id, true);
                break;
            }
        }
    };
    return ListExpressionRenderer;
}(ExpressionRenderer));
export { ListExpressionRenderer };
var CustomListExpressionRenderer = /** @class */ (function (_super) {
    __extends(CustomListExpressionRenderer, _super);
    function CustomListExpressionRenderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoading = false;
        _this.onClickTemp = null;
        return _this;
    }
    CustomListExpressionRenderer.prototype.renderEditor = function () {
        var _this = this;
        if (this.isLoading)
            return;
        this.isLoading = true;
        this.fillMenuItemsList(function () {
            _this.isLoading = false;
            if (_this.isEmptyValue()) {
                _this.takeDefaultValue();
            }
            if (!_this.expression.isEmpty() && _this.expression._isDefaultValue) {
                var text = _this.getValueText(_this.expression.value);
                _this.expression.setContent(_this.expression.value, text);
                _this.expression.getParent().fireChangedEvent();
            }
            _this.renderMenuBlock();
            if (_this.showWhenReady) {
                _this.showWhenReady = false;
                _this.hideLoader();
                _this.showEditor();
            }
        });
    };
    CustomListExpressionRenderer.prototype.showLoader = function () {
        this.labelElement.style.display = 'none';
        if (!this.loaderElement) {
            this.loaderElement = domel('div', this.element)
                .addClass(this.cssPrefix + "-ve-loader")
                .toDOM();
        }
        this.loaderElement.style.display = 'block';
    };
    CustomListExpressionRenderer.prototype.hideLoader = function () {
        this.loaderElement.style.display = 'none';
        this.labelElement.removeAttribute('style');
    };
    CustomListExpressionRenderer.prototype.fillMenuItemsList = function (onComplete) {
        var _this = this;
        var listName = this.getListName();
        var listRequestHandler = this.panel.getContext().getListRequestHandler();
        if (eqconsts.constLists[listName]) {
            this.menuItemsList = eqconsts.constLists[listName];
            if (onComplete) {
                onComplete();
            }
        }
        else if (listRequestHandler) {
            listRequestHandler({
                listName: listName,
                editorId: this.valueEditor.id,
                editorParams: this.valueEditor.extraParams,
                value: this.getValue()
            }, function (list) {
                _this.menuItemsList = list;
                if (onComplete) {
                    onComplete();
                }
            });
        }
    };
    return CustomListExpressionRenderer;
}(ListExpressionRenderer));
export { CustomListExpressionRenderer };
var SqlListExpressionRenderer = /** @class */ (function (_super) {
    __extends(SqlListExpressionRenderer, _super);
    function SqlListExpressionRenderer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SqlListExpressionRenderer.prototype.fillMenuItemsList = function (onComplete) {
        var _this = this;
        var context = this.panel.getContext();
        var editor = this.valueEditor;
        var listRequestHandler = context.getListRequestHandler();
        if (listRequestHandler) {
            var requestData = {
                listName: "SQL",
                editorId: this.valueEditor.id,
                editorParams: this.valueEditor.extraParams,
                value: this.getValue()
            };
            //requestData.sql = editor.sql;
            listRequestHandler(requestData, function (list) {
                _this.menuItemsList = list;
                if (onComplete) {
                    onComplete();
                }
            });
        }
    };
    return SqlListExpressionRenderer;
}(CustomListExpressionRenderer));
export { SqlListExpressionRenderer };
//# sourceMappingURL=list_expression_renderer.js.map